export const PortfolioSW = {
  EDIT: 'Redigera',
  HISTORY: 'Historia',
  EXPORT: 'Exportera',
  EXPORT_PORT: 'Exportera',
  DRAFT_PORTFOLIO: 'Utkast till portfölj',
  CURRENT_PORTFOLIO: 'Nuvarande portfölj',
  DELETE: 'Radera',
  LAUNCH_CITRONEER_QUANT: 'Starta Citroneer Quant',
  OPTIMIZE: 'Optimera',
  PORTFOLIO: 'Portfölj',
  PORTFOLIOS: 'Portföljer',
  REPORT: 'Rapport',
  CLIENTS_LABEL: 'KUND',
  CATEGORY: 'Kategori',
  ASSET_CLASS: 'Tillgångsslag',
  INSTRUMENT: 'Instrument',
  ISIN: 'ISIN',
  VALUE: 'Värde',
  FEE: 'Avgift',
  ASSET_ALLOCATION: 'Tillgångsallokering i procent',
  CANCEL: 'Avbryt',
  ADD: 'Lägg till',
  IMPORT_FROM_EXCEL: 'Importera från Excel',
  SAVE: 'Spara',
  OPERATION: 'Drift',
  UNITS: 'Antal',
  SHARE_PRICE: 'Aktiekurs',
  CREATE_PORTFOLIO: 'Skapa portfölj',
  EDIT_DRAFT_PORTFOLIO: 'Redigera utkast till portfölj',
  NO_PORTFOLIO: 'Ingen portfölj',
  NO_PORTFOLIO_TEXT:
    'Det verkar som om du inte har någon portfölj, redigera ditt utkast av portföljen eller skapa en ny',
  ADD_INSTRUMENT: 'Lägg till instrument',
  EDIT_INSTRUMENTS: 'Redigera instrument',
  ALL_ADVISORS: 'Alla rådgivare',
  ACTIVATE_ADVISOR: 'Aktivera rådgivare',
  CREATE_ADVISOR: 'Skapa rådgivare',
  INVITE_ADVISOR: 'Bjud in rådgivare',
  ADVISOR_LIST: 'Rådgivarlista',
  APPROVE: 'Godkänn',
  HISTORY_EMPTY: 'Historiken är tom',
  GO_PORTFOLIO: 'Gå portfölj',
  UPLOAD_REPORT: 'Ladda upp rapport',
  DOWNLOAD: 'Ladda ner',
  REPORTS: 'Rapporter',
  CHOOSE_FILE: 'Välj FIL',
  NO_FILE_CHOSEN: 'Ingen fil vald',
  UPLOAD: 'Ladda upp',
  ASSET_CATEGORY: 'Tillgångskategori',
  NAME: 'Namn',
  SYS_NAME: 'Sys namn',
  CREATE: 'Skapa',
  INVITE: 'Bjud in',
  CREATE_INSTRUMENT: 'Skapa instrument',
  ENTER_REPORT_NAME: 'Ange rapportnamn',
  TBD_TOOLTIP_TEXT:
    'Detta instrument är för närvarande inte kartlagt.' +
    ' Citroner-teamet har meddelats och kommer att mappa instrumentet så ' +
    'snart som möjligt. ' +
    'När det gäller vet kan portföljen bara sparas som ett utkast men när' +
    ' instrumentet kartläggs kommer portföljen automatiskt att verifieras.',
  INSTRUMENTS_REQUESTS: 'Instrument begäranden',
  SENT_SUCCESSFULLY: 'Portföljen skickades',
  REQUEST_FOR_OPTIMIZATION:
    'Begäran om optimering har redan skickats till Admin',
  TOTAL_PORTFOLIO_VALUE: 'Totalt Portfölj Värde',
  TOTAL: 'Totalt',
  CREATED: 'Skapad',
  LAST_MODIFIED: 'Senast ändrad',
  REPLACE_DRAFT: 'Byt utkast',
  REPLACE_CURRENT: 'Byt ut nuvarande',
  REPLACE_DRAFT_TEXT: 'Vill du verkligen byta utkast till portföljen?',
  REPLACE_CURRENT_TEXT: 'Vill du verkligen ersätta den nuvarande portföljen?',
  IMPORT: 'Importera',
  SYS_NAME_UPPER: 'SYS_NAMN',
  PORTFOLIO_INFORMATION: 'Portföljinformation',
  CONTINUE: 'Fortsätt',
  ENTER_THE_NAME: 'Ange namnet',
  AVAILABLE_CASH: 'Likvida medel',
  TAX_RATE: 'Skattenivå',
  DEPOSIT_FEE: 'Depositionsavgift',
  ADVISORY_FEE: 'Rådgivningsavgift',
  CAPITAL_GAIN: 'Kapitalvinst',
  FLAT_RATE: 'Fast pris',
  CHOOSE_METHOD_TAXATION: 'Välj en beskattningsmetod',
  TAXATION: 'Beskattning',
  LISTED_HOLDINGS: 'Börsnoterade Innehav',
  DELETE_PORTFOLIO: 'Ta bort portfölj',
  CREATE_NEW_PORTFOLIO: 'Skapa ny portfölj',
  PORTFOLIO_NUMBER: 'Portföljnummer',
  ENTER_PORTFOLIO_ID_FROM_FA: 'Ange portfölj-ID från FA',
  EXPORT_PORTFOLIO: 'Exportportfölj',
  EXPORT_PORTFOLIOS: 'Exportportföljer',
  EXPORT_PORTFOLIO_PROMT: 'Exportera portföljen till Excel:',
  EXPORT_PORTFOLIOS_PROMT: 'Exportera portföljerna till Excel:',
  CHOOSE_PORTFOLIOS: 'Välj portföljer',
  CHOOSE_PORTFOLIO: 'Välj portfölj',
  SELECT_PORTFOLIO: 'Välj Portfölj *',
  SELECT_PORTFOLIOS: 'Välj Portföljer',
  CHOOSE_CANDIDATE: 'Välj kandidat',
  ADD_ADDITIONAL_STEPS: 'Lägg till ytterligare steg',
  MIN_MAX_CONSTRAINTS: 'Min/Max',
  PORTFOLIO_CONSTRAINTS: 'Portföljinställningar',
  CURRENCY: 'Valuta',
  INSTRUMENTS_TAB: 'Instrument',
  HOLDINGS: 'Innehav',
  UNLISTED_HOLDINGS: 'Onoterade Innehav',
  EDIT_PORTFOLIO: 'Redigera portfölj',
  EXPORT_PORTFOLIO_TO: 'Exportera till Excel portfölj',
  MINMAX: 'Min/Max',
  WITH_IMPORT_INSTRUMENT: 'Importera portfölj från Excel',
  DOWNLOAD_THE_TEMPLATE_EXCEL: 'Ladda ner mallen i Excel-format',
  FAILED_TO_IMPORT: 'Det gick inte att importera',
  CONFIRM_DELETION: 'Bekräfta radering',
  TEXT_DELETION: 'Är du säker på att du vill ta bort portföljen',
  CLIENT_DELETION: 'Är du säker på att du vill ta bort kunden::',
  TRANSACTIONS: 'Transaktioner',
  BUY_TRANSACTIONS: 'Köptransaktioner',
  SELL_TRANSACTIONS: 'Säljtransaktioner',
  TICKER: 'Ticker',
  OPTIMIZED_PORTFOLIO: 'Optimerad portfölj',
  CREATE_REPORT: 'Skapa rapport',
  REPORT_TEXT: 'Vill du skapa en rapport för denna portföljoptimering?',
  REPORT_TEXT_TYPE: 'Typ av rapport',
  FINISH: 'Skapa rapport',
  FINISH_COMPOSITE: 'Slut',
  ALLOCATION: 'Allokering',
  GO_BACKWARD: 'Gå bakåt',
  GO_FORWARD: 'Gå framåt',
  TEXT_DELETION_INSTRUMENT: 'Är du säker på att du vill ta bort instrumentet:',
  TEXT_DELETION_MAP: 'Är du säker på att du vill ta bort rekommendationskartan:',
  TEXT_DELETION_REQUEST: 'Är du säker på att du vill ta bort begäran:',
  CONNECT: 'Sammankoppla',
  CONNECT_INSTRUMENT: 'Sammankoppla instrument',
  MAP_INSTRUMENT: 'Välj det instrument du vill mappa denna begäran till:',
  SELECT_INSTRUMENT: 'Välj instrument',
  SELECT_INSTRUMENT_FOR: 'Välj instrument för mappning',
  TOTAL_FEE: 'Total avgift',
  ACTIVATE_SYNCHRONIZATION: 'Aktiv synkronisering',
  LAST_SYNC: 'Senaste lyckade synkroniseringen',
  PORTFOLIO_TYPE: 'Portföljtyp (Optimering)',
  CHOOSE_PORTFOLIO_TYPE: 'Välj Portföljtyp',
  PORTFOLIO_TYPE_ONE: 'Quant',
  PORTFOLIO_TYPE_TWO: 'Quant ESG',
  PORTFOLIO_TYPE_THREE: '4-Fond',
  OVERVIEW: 'Översikt',
  ORDER_INSTRUCTIONS: 'Orderinstruktioner',
  MONITORING: 'Övervakning',
  DOCUMENTS: 'Dokument',
  CONSTRAINTS: 'Portföljinställningar',
  FIXATION: 'Fixering',
  CASH: 'Kontanter',
  FX_RATE: 'FX Kurs',
  MIN: 'Min',
  MAX: 'Max',
  INSTRUMENTS: 'Instrument',
  NO_SHARES: 'Antal',
  NO_SHARES_TO_FIX: 'Fixera antal',
  FIX: 'Fixera allt',
  BUY: 'Köp',
  SELL: 'Sälj',
  UPDATE: 'Uppdatera',
  VALID_UNTIL: 'Giltig till',
  UNTIL_CANCELED: 'Tills avbokning',
  SHARE_PR: '% Andel',
  APPROVED_INSTRUMENT: 'Godkänt instrument',
  ADD_PORTFOLIO: 'Lägg till portfölj',
  OPTIMISE: 'Optimera',
  ANALYZE: 'Analysera',
  STANDING: 'Stående',
  RETURN_PER: 'Avkastning %',
  VOLATILITY_PER: 'Volatilitet %',
  CVAR_PER: 'CVaR %',
  REBALANCE: 'Rebalansera',
  GLOBAL_SHARES: 'Global aktier',
  LIQUIDITY: 'Likviditet',
  START_OPTIMIZATION: 'Starta optimering',
  DISTRIBUTION: 'Distribution',
  ASSET_CLASS_ALLOCATION: 'Tillgångsklassfördelning',
  VIEW_MORE: 'Visa mer',
  ADD_CLIENT: 'Lägg till kund',
  ADD_ACCOUNT: 'Lägg till konto',
  INFORMATION: 'Information',
  FINANCIAL_PLANING: 'Finansiell planering',
  PORTFOLIO_DETAILS: 'Portföljdetaljer',
  THAN_LAST_MONTH: 'än förra månaden',
  THAN_LAST_3_MONTHS: 'än de senaste 3 månaderna',
  THAN_LAST_YEAR: 'än förra året',
  RESET: 'Återställ',
  PORTFOLIO_OPTIMISE: 'Portföljoptimera',
  PORTFOLIO_OPTIMISATION: 'Portföljoptimering',
  CHANGE_SETTINGS: 'Ändra inställningar',
  BACK_TO_OPTIMISE: 'Tillbaka till Effektiva fronten',
  BACK_TO_TRANSACTIONS: 'Tillbaka till Transaktioner',
  OPT_BREAK: 'Du är på väg att lämna optimeringsflödet. All inmatad information kommer att gå förlorad. Är du säker på det här?',
  CLIENT_CREATION: 'Kundskapande',
  ACCOUNT_CREATION: 'Skapa konto',
  NOPORTFOLIO_TEXT: 'Det verkar som att du inte har någon portfölj, vänligen redigera ditt utkast till portfölj eller skapa en ny',
  PORTFOLIO_CREATION: 'Skapande av portfölj',
  MAIN_INFORMATION: 'Huvudinformation',
  CLEAR: 'Klar',
  DETAIL_TEXT: 'Vänligen fyll i information för att se portföljens resultat',
  PRODUCT_NAME: 'Produktnamn',
  OPTIMIZATION: 'Optimering',
  LIKE_TO_INCLUDE: 'Vilka avgifter skulle du vilja inkludera?',
  EDIT_ADVISOR_INFORMATION: 'Redigera rådgivareinformation',
  ADVISOR_INVITATION: 'Rådgivarinbjudan',
  WEIGHT: 'Vikt',
  CASH_MANAGEMENT: 'likviditetshantering',
  MINIMUM_CASH_LEVEL: 'Lägsta likviditetsnivå',
  CASH_AMOUNT: 'Likvida medel',
  //
  BY: 'av',
  CREATED_ON: 'Skapad',
  UPDATED_ON: 'Uppdaterad',
  LAST_OPTIMIZED_ON: 'Senast optimerad den',
  PERFORMANCE: 'Utveckling',
  EXCLUDE_HOLDINGS: 'Exkludera innehav',
  EXCLUDE_ASSET_CLASS: 'Exkludera tillgångsklass',
  LIFETIMING: 'Lifetiming',
  FINANCIAL_PLAN_BETA: 'Finansiell plan Beta',
  FINANCIAL_PLANS: 'Finansiella planer',
  CREATE_FINANCIAL_PLAN: 'Skapa finansiell plan',
  ADD_FINANCIAL_PLAN: 'Lägg till finansiell plan',
  NO_FINANCIAL_PLANS: 'Inga finansiella planer',
  NO_FINANCIAL_PLANS_TEXT: 'Det verkar som att du inte har någon finansiell plan, skapa en ny.',
  ASSIGNED_TO_PORTFOLIO: 'Tilldelad till Portfolio',
  NOF_ITEMS: 'Antal artiklar',
  ACHIEVEMENT_LEVEL: '% uppnått',
  YEARS: 'år',
  SUBMIT_AND_PROCEED: 'Skicka in och fortsätt',
  FINANCIAL_PLAN_CREATION: 'Skapande av finansiell plan',
  PLEASE_PROVIDE: 'Ange finansiella planens namn',
  FINANCIAL_PLAN_NAME: 'Finansiella planens namn',
  FINANCIAL_PLAN_DETAILS: 'Finansiell plan Detaljer',
  DELETE_FINANCIAL_PLAN: 'Ta bort finansiell plan',
  END_DATE: 'Slutdatum ',
  DISTRIBUTION_NEW: 'Distribution',
  ADD_ITEM: 'Lägg till objekt',
  EXPENSES: 'Utgifter',
  INCOME: 'Inkomst',
  NECESSITY: 'Nödvändighet',
  PURPOSE: 'Syfte',
  HAPPINESS: 'Lycka',
  SALARY: 'Lön',
  PENSION: 'Pension',
  INCOME_FROM_OTHER: 'Övriga inkomster',
  PROPERTY_SALE: 'Fastighetsförsäljning',
  RETURN_ON_INVESTMENTS: 'Avkastning på investeringar',
  SALE_OTHER: 'Försäljning (övrigt)',
  INHERITANCE: 'Arv',
  HOUSING: 'Hus',
  HEALTH: 'Hälsa',
  KIDS: 'Barn',
  EDUCATION: 'Utbildning',
  VACATION_PLANNER: 'Semesterplanerare',
  VEHICLES: 'Fordon',
  LUXURY_GOODS: 'Lyxvaror',
  LIVING_EXPENSES: 'Levnadskostnader',
  GIFTS: 'Gåvor',
  ADD_ITEMS_NECESSARY_CATEGORY: 'Lägg till objekt i nödvändig kategori.',
  WHAT_WANT_ACHIVE: 'Vad vill du uppnå?',
  ITEM_NAME: 'Objektets namn',
  ENTER_ITEM_NAME: 'Ange objektets namn',
  DESCRIPTION: 'Beskrivning',
  ENTER_DESCRIPTION: 'Ange en beskrivning...',
  FREQUENCY: 'Frekvens',
  PROBABILITY: 'Sannolikhet',
  CLOSE: 'Nära',
  VIEW_AS_CHART: 'Visa som diagram',
  VIEW_AS_LIST: 'Visa som lista',
  CREATION_DATE: 'Skapad',
  HOLDINGS_FEE_TOOLTOP: 'Vägd genomsnittlig avgift för instrumenten',
  TO_SYNC_PORTFOLIOS: 'För att synkronisera portföljer anslut ditt BankId i Inställningar',
  NOT_AVAILABLE_FOR_EDITING: 'Portföljen är inte tillgänglig för redigering',
  IN_EXECUTION: 'Pågående handel',
  LOCKED: 'Låst',
  INVESTOR_BIAS_TOOLTIP: 'Välj den procentandel av aktiekorgen som du vill ska bestå av Investor Bias. I en 80/20-portfölj kommer det rekommenderade instrumentet att utgöra 8 % av den totala portföljen om 10 % anges. 0,10 x 0,80 = 0,08.',
  WANT_TO_CREATE_IT: 'Vill skapa det:',
  MANUALLY: 'Manuellt',
  FROM_NJORDA: 'Från extern institution',
  MY_TOTAL_WEALTH: 'Min totala värde',
  INCLUDED_PORTFOLIOS: 'Inkluderade portföljer',
  OWNER: 'Ägare',
  DATE: 'Datum',
};
